<script setup lang="ts">
import { useRoute } from 'vue-router'
import { ref, inject, watch, provide } from 'vue'
import { useApi } from '@/store/useAppStore'
import UserApi from '@/services/api/core/UserApi'
import SubProject from './SubProject.vue'
import SubProjectsParameters from '../SubProjectsParameters.vue'

interface Props {
  subProjects: any
}

const props = withDefaults(defineProps<Props>(), {})

const emit = defineEmits(['subProjectTaskModified'])

const route = useRoute()
const userApi: UserApi = useApi()

function onSubProjectTaskModified(event) {
  emit('subProjectTaskModified', event)
}

const subProjectPersonalModels = await userApi.getSubProjectPersonalModels()
provide("subProjectPersonalModels", subProjectPersonalModels)
</script>

<template>
  <div>
    <SubProject v-for="subProjectId in subProjects" :projectId="subProjectId.id"
      @subProjectTaskModified="onSubProjectTaskModified($event)">
    </SubProject>
  </div>
</template>

<style lang="scss" scoped></style>
